import ErrorLogger from '../utils/ErrorLogger';

const kyErrorLoggerHook = (request, _options, response: Response) => {
  if (response.status >= 400) {
    ErrorLogger.captureException(
      new Error(`${request.method} ${request.url} ${response.status} (${response.statusText})`)
    );
  }
};

export default kyErrorLoggerHook;
